import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router';
import {bindActionCreators} from 'redux';
import Fuse from 'fuse.js';
import FontAwesome from 'react-fontawesome';
import * as actions from '../../actions/userActions';
import Button from '../../components/common/Button';
import PermissionLink from '../../components/common/PermissionLink';

const group_names = {
  super_admin: 'Super-admin',
  event_admin: 'Arrangement-admin',
  single_event_admin: 'Enkeltarrangement-admin',
  club_admin: 'Klubb-admin',
};

class UsersPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.delete = this.delete.bind(this);
    this.filterUsers = this.filterUsers.bind(this);
    this.state = {
      filter: ""
    };
  }

  componentWillMount() {
    this.props.actions.loadUsers();
  }

  delete(e, id) {
    if (!confirm('Bekreft at du ønsker å slette')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.deleteUser(id);
  }


  filterUsers(e) {
    let filter = e.target.value;
    this.setState({
      filter: filter
    });
  }

  render() {
    let filteredList = this.props.list;
    if(this.state.filter) {
      let searchUsers = new Fuse(this.props.list,{
        keys: ["first_name", "last_name", "email", "username"]
        });
      filteredList = searchUsers.search(this.state.filter);
    }
    return (
      <div className="clubs-page-container container form-inline">
        <div className="page-header clearfix">
          <h1>
            Brukere
          </h1>
          <div className="pull-right">
            <div className="input-group hidden-xs">
              <span className="input-group-addon" id="basic-addon3">
                <FontAwesome
                  name="search" />
              </span>
              <input
                type="text"
                className="form-control"
                onChange={this.filterUsers}
                value={this.state.fitler}
                />
            </div>
            {' '}
            <Link to={"/bruker/ny"} className="btn btn-primary">
              Ny bruker
            </Link>
          </div>
        </div>
        <table className="table table-responsive table-bordered table-background">
          <thead>
            <tr>
              <th>Fornavn</th>
              <th>Etternavn</th>
              <th>Brukernavn</th>
              <th>Epost</th>
              <th>Rettigheter</th>
              <th>Klubber</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {filteredList.map((user, index) => {
              return (
                <tr key={index}>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>
                    {user.group_list.map((group) => {
                      return group_names[group.name];
                    }).join(', ')}
                  </td>
                  <td>
                    {user.club_list.map((club) => {
                      return club.name;
                    }).join(', ')}
                  </td>
                  <td className="text-right no-break">
                    <Button
                      permission={user.permissions.write}
                      className="btn btn-danger"
                      faName={'trash'}
                      onClick={(e) => {this.delete(e, user.id);}}>
                      <span className="hidden-xs">{' Slett'}</span>
                    </Button>
                    {' '}
                    <PermissionLink
                      permission={user.permissions.write}
                      to={'/bruker/' + user.id}
                      className="btn btn-primary"
                      faName="edit">
                      <span className="hidden-xs">{' Rediger'}</span>
                    </PermissionLink>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

UsersPage.propTypes = {
  actions: PropTypes.object.isRequired,
  list: PropTypes.array,
  loading: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    list: state.users.list,
    loading: state.users.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);



/** WEBPACK FOOTER **
 ** ./src/containers/users/UsersPage.js
 **/